import React, { ReactNode, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, RowProps } from 'antd';
import useWindowSize, { DESKTOP_WIDTH } from 'app/hooks/useWindowSize';

interface Props extends RowProps {
  children: ReactNode;
}

export const CONTAINER_SIZE = {
  LARGE: 1832,
  NORMAL: 1328,
};

export const PAGES_HAVE_LARGE_SIZE: string[] = [];

const ContainerFluid: React.FC<Props> = ({ children, style, ...restProps }) => {
  const { pathname } = useLocation();
  const {
    windowSize: { width: screenWidth },
  } = useWindowSize();

  const isHasLargeSize = PAGES_HAVE_LARGE_SIZE.includes(pathname);

  const maxWidth = useMemo(() => {
    switch (true) {
      case screenWidth >= DESKTOP_WIDTH:
        return isHasLargeSize
          ? `${CONTAINER_SIZE.LARGE}px`
          : `${CONTAINER_SIZE.NORMAL}px`;

      case screenWidth >= 992:
        return '960px';

      case screenWidth >= 768:
        return '720px';

      case screenWidth >= 576:
        return '540px';

      default:
        return '100%';
    }
  }, [isHasLargeSize, screenWidth]);

  return (
    <Row
      style={{
        maxWidth,
        width: '100%',
        padding: '0 16px',
        margin: '0 auto',
        ...style,
      }}
      {...restProps}
    >
      {children}
    </Row>
  );
};

export default ContainerFluid;
